import TokenHelper from "./TokenHelper"
import ProviderHelper from "./ProviderHelper"
import CouponHelper from "./CouponHelper"
import CryptoStorageHelper from "./CryptoStorageHelper"
import DataStorage from "./DataStorage"

export default {
    ...ProviderHelper,
    ...CouponHelper,
    ...TokenHelper,
    CryptoStorage: CryptoStorageHelper,
    DataStorage,
}